angular.module('dnecom').service('StatisticsTabs', function() {
    var tabs = {
        $tabs: [],
        $current: false,
        all: function() {
            return this.$tabs;
        },
        has: function(index) {
            return this.$tabs.hasOwnProperty(index);
        },
        count: function() {
            if (this.has(this.$current)) {
                return this.$tabs[this.$current].items.length;
            }

            return 0;
        },
        change: function(index) {
            if (false === this.isActive(index) && this.has(index)) {
                this.$current = index;
            }
        },
        data: function() {
            if (this.has(this.$current)) {
                return this.$tabs[this.$current].items;
            }
        },
        width: function(columns) {
            return Math.floor(columns / this.count());
        },
        isActive: function(index) {
            return index === this.$current;
        },
        createInstance: function() {
            return _.clone(tabs);
        }
    };

    return tabs;
});
